import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import appLogger from 'app/shared/loggers/appLogger';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

const CreditCardCharge = ({
    apiAccessToken,
    isCharged,
    isInitiateChargeFailedValidPaymentExists,
    isRenderedInPageView,
    modalDialogHeaderEl,
    onCharge,
    onChargeFail,
    onChargeSuccess,
}) => {
    useEffect(() => {
        if (apiAccessToken) {
            onCharge(apiAccessToken).then(onChargeSuccess, onChargeFail);
        }
        // if valid payment already exists, skip onCharge and directly handle onChargeSuccess
        if (isInitiateChargeFailedValidPaymentExists) {
            onChargeSuccess();
        }
    }, [apiAccessToken, isInitiateChargeFailedValidPaymentExists]);

    // set modal title via ref
    useEffect(() => {
        if (!modalDialogHeaderEl) {
            appLogger.logError({
                message: `ERROR: modalDialogHeaderEl does not exist ${modalDialogHeaderEl}`,
                context: 'CreditCardCharge',
            });

            return;
        }

        let title = '';
        modalDialogHeaderEl.innerHTML = '';

        if (isCharged) {
            if (isRenderedInPageView) {
                title = 'Payment successful.';
            } else {
                title = 'Activating your listing.';
            }
        } else {
            title = 'Please wait while we process your payment.';
        }

        modalDialogHeaderEl.innerHTML = title;
    }, [isCharged, isRenderedInPageView, modalDialogHeaderEl]);

    const hideSpinner = isRenderedInPageView && isCharged;

    return (
        <div className="CreditCardCharge">
            {!hideSpinner && <SpinnerContainer />}
        </div>
    );
};

CreditCardCharge.propTypes = {
    isCharged: PropTypes.bool.isRequired,
    apiAccessToken: PropTypes.string.isRequired,
    onCharge: PropTypes.func.isRequired,
    onChargeSuccess: PropTypes.func.isRequired,
    onChargeFail: PropTypes.func.isRequired,
    isRenderedInPageView: PropTypes.bool.isRequired,
    isInitiateChargeFailedValidPaymentExists: PropTypes.bool.isRequired,
    modalDialogHeaderEl: PropTypes.node.isRequired,
};

export default CreditCardCharge;
